// @ts-nocheck
import React from 'react';
import { List, ListItem, ListItemText, Box } from '@mui/material';
import DOMPurify from 'dompurify';
import { renderDateTime } from 'utils/helpers';

export default function PenlyAccessLegacyNotes({ init }) {
    const notes = Array.isArray(init) ? init : [];

    return (
        <Box>
            <p>Historiske noter fra tidligere samtaler. De er skrivebeskyttede.</p>
            <List>
                { notes.map((note, index) => (
                    <ListItem
                        key={ note?.legacyId || note?._id || `legacy-note-${index}` }
                        sx={{
                            backgroundColor: 'grey.200',
                            padding: 2,
                            marginBottom: 2,
                            borderRadius: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                        }}
                    >
                        <ListItemText
                            primary={ note?.sender?.name || '-' }
                            secondary={ renderDateTime(note?.createdAt || note?.date) }
                            primaryTypographyProps={{ variant: 'h6' }}
                            secondaryTypographyProps={{ variant: 'body2' }}
                        />
                        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(note?.content || '') }} />
                    </ListItem>
                )) }
            </List>
        </Box>
    );
}
